import {FormBuilder, FormGroup} from "@angular/forms";
import { Component, inject, OnInit } from '@angular/core';

import {Validators} from "angular-reactive-validation";
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import {Portals} from "@qwyk/models";

@Component({
    selector: 'qwyk-quotation-network-rate-request',
    templateUrl: './quotation-network-rate-request.component.html',
    styleUrls: ['./quotation-network-rate-request.component.scss']
})
export class QuotationNetworkRateRequestComponent implements OnInit {

    private fb = inject(FormBuilder);
    protected dialogRef = inject(DynamicDialogRef);

    public quotation: Portals.QuotationEntity;
    public error = null;
    public form: FormGroup;
    public reasons = [
        'I need a better rate',
        'I would like a different option',
        'I did not find any rates',
        'Other',
    ];

    private _busy = false;

    public get busy(): boolean {
        return this._busy;
    }

    public set busy(busy) {
        if (busy !== this._busy) {
            this._busy = busy;
            if (this._busy) {
                this.form.disable();
            } else {
                this.form.enable();
            }
        }
    }

    public get iconAnimation(): 'pulse' | undefined {
        return this.busy ? 'pulse' : undefined;
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            reason: [
                null,
                [Validators.required('Select a reason')],
            ],
            remarks: [
                null,
                [
                    Validators.maxLength(
                        255,
                        maxLength => `Enter at most ${maxLength} characters`
                    ),
                ],
            ],
        });
    }

    /**
     * Emits a send event when the form validation has succeeded
     */
    public onSend() {
        this.error = null;
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }
        this.dialogRef.close(this.form.getRawValue());
    }

    /**
     * Dismisses the modal.
     */
    public onCancel() {
        this.dialogRef.close();
    }
}
